import { render, staticRenderFns } from "./PxMensagensPersonalizadasList.vue?vue&type=template&id=c1bf58e8&scoped=true&"
import script from "./PxMensagensPersonalizadasList.vue?vue&type=script&lang=js&"
export * from "./PxMensagensPersonalizadasList.vue?vue&type=script&lang=js&"
import style0 from "./PxMensagensPersonalizadasList.vue?vue&type=style&index=0&id=c1bf58e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bf58e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
